import { type UUID } from "../utils"
import type { OrganizationDto, OrgSettingsUpdateDto } from "./Organization"
import {
  type DbOrganizationsUpdate,
  type IOrgRepository,
} from "./org-repository"

export interface IOrgService {
  create(principalId: UUID, orgSettings: OrgSettingsUpdateDto): Promise<boolean>
  getById(orgId: UUID): Promise<OrganizationDto | null>
  listAllOrgs(): Promise<OrganizationDto[]>
  updateSettings(
    principalId: UUID,
    orgId: UUID,
    data: OrgSettingsUpdateDto
  ): Promise<boolean>
}

export class OrgService implements IOrgService {
  constructor(private readonly orgsRepo: IOrgRepository) {}

  async create(
    principalId: UUID,
    orgSettings: OrgSettingsUpdateDto
  ): Promise<boolean> {
    return await this.orgsRepo.create(principalId, orgSettings)
  }

  async getById(orgId: string): Promise<OrganizationDto | null> {
    return await this.orgsRepo.getById(orgId)
  }

  async listAllOrgs(): Promise<OrganizationDto[]> {
    console.debug("> OrgService.listAllOrgs")
    // Should this check if the user is SUPER_ADMIN?
    return await this.orgsRepo.listAllOrgs()
  }

  async updateSettings(
    principalId: UUID,
    orgId: UUID,
    orgData: OrgSettingsUpdateDto
  ): Promise<boolean> {
    const dbOrgData: DbOrganizationsUpdate = {
      ...orgData,
      address:
        null === orgData.address || typeof orgData.address === "string"
          ? orgData.address
          : JSON.stringify(orgData.address),
    }
    return await this.orgsRepo.updateSettings(principalId, orgId, dbOrgData)
  }
}

export const stripLargeObjectsFromOrgs = (orgs: OrganizationDto[]) => {
  console.debug("> stripLargeObjectsFromOrgs")
  type DeviceOrgDto = Omit<
    OrganizationDto,
    "Ausladegruppen" | "FeedComponents" | "Recipes"
  >
  const transformedOrgs: DeviceOrgDto[] = []
  for (const org of orgs) {
    const { Ausladegruppen, FeedComponents, Recipes, user_role, ...deviceOrg } =
      org
    transformedOrgs.push(deviceOrg)
  }
  console.debug("Stripped orgs:", JSON.stringify(transformedOrgs, null, 2))
  console.debug("< stripLargeObjectsFromOrgs")
  return transformedOrgs
}
